module.exports = __webpack_public_path__ + "static/media/vit_logo.5e1a68cb.png";